export default __webpack_public_path__ + "static/media/timezone.ed725c8b.svg";